import angular from 'angular';
import { kebabCase } from 'lodash';

import _css from './od-collapsible-question.less';

module.exports = angular.module('market.components.od-collapsible-question', [
])
.component('odCollapsibleQuestion', {
  bindings: {
    question: '@'
  },
  transclude: true,
  template: require('./od-collapsible-question.jade')(),
  controller: class {
    constructor($location, $element) {
      this.questionId = kebabCase(this.question);
      $element[0].id = this.questionId;
      this.$location = $location;

      if (this.questionId === $location.hash()) {
        this.collapsed = false;
      } else {
        this.collapsed = true;
      }
    }

    setQuestionId() {
      this.$location.hash(this.questionId);
      this.collapsed = false;
    }
  }
 })
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-collapsible-question.js
 **/